











































































import {Component, Vue, Inject, Prop, Watch} from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateOrganization from "./create.vue";
import EditOrganization from "./edit.vue";
import dayjs from "dayjs";
import Organization from "@/store/entities/organization";

class PageOrganizationRequest extends PageRequest {
 
}

@Component({
  components: {CreateOrganization, EditOrganization},
})
export default class OrganizationsVM extends AbpBase {
  edit() {
    this.editModalShow = true;
  }

  pageRequest: PageOrganizationRequest = new PageOrganizationRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;

 
  get list() {
    return this.$store.state.organization.list;
  }

  get loading() {
    return this.$store.state.organization.loading;
  }

  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("organization/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("organization/setPageSize", pagesize);
    this.getpage();
  }

  async getpage() {
     
    this.pageRequest.maxResultCount = this.pageSize;
    this.pageRequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: "organization/getAll",
      data: this.pageRequest,
    });
  }

  get pageSize() {
    return this.$store.state.organization.pageSize;
  }

  get totalCount() {
    return this.$store.state.organization.totalCount;
  }

  get currentPage() {
    return this.$store.state.organization.currentPage;
  }

  columns = [
    {
      title: this.L("ID"),
      key: "id",
    },
    {
      title: this.L("名称"),
      key: "displayName",
    },
    {
      title: this.L("代码"),
      key: "code",
    },
     
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => {
                    this.$store.commit("organization/edit", params.row);
                    this.edit();
                  },
                },
              },
              this.L("Edit")
          ),
          h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: this.L("Tips"),
                      content: this.L("删除这个组织？"),
                      okText: this.L("Yes"),
                      cancelText: this.L("No"),
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "organization/delete",
                          data: params.row,
                        });
                        await this.getpage();
                      },
                    });
                  },
                },
              },
              this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    await this.getpage();
  }
}
